import React, { useEffect, useState } from 'react';
import Modal from '../../../component/modal/ModalTemplate';
import * as apiUtil from '../../../util/apiUtil';
import { SECONDARY_BTN, FOOTER_END, TH, TD } from "./modalStyle";

interface AgreeHistoryItem {
    channelName: string;
    actionTypeName: string;
    actionAt: string;
    sourceName: string;
}

interface MarketingAgreeHistoryModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
}

const MarketingAgreeHistoryModal: React.FC<MarketingAgreeHistoryModalProps> = ({ isOpen, onRequestClose }) => {
    const [list, setList] = useState<AgreeHistoryItem[]>([]);

    useEffect(() => {
        if (!isOpen) return;
        apiUtil.asyncRequest({
            url: '/api/bizchat/user/agreement/history',
            method: apiUtil.requestMethod.POST,
            success: (result: AgreeHistoryItem[]) => setList(result || []),
        });
    }, [isOpen]);

    return (
        <Modal open={isOpen} handleClose={onRequestClose} modalTitle="마케팅 수신 동의 이력" className="react-modal">
            <div className="modal-body tw-overflow-x-auto">
                <table className="tw-w-full tw-border-collapse tw-text-center tw-text-sm">
                    <thead>
                        <tr>
                            <th className={TH}>채널</th>
                            <th className={TH}>처리</th>
                            <th className={TH}>일시</th>
                            <th className={TH}>경로</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.length === 0 ? (
                            <tr>
                                <td className={`${TD} tw-py-4 tw-text-[#A0A0A0]`} colSpan={4}>이력이 없습니다.</td>
                            </tr>
                        ) : (
                            list.map((item, index) => (
                                <tr key={`${item.actionAt}-${index}`}>
                                    <td className={TD}>{item.channelName}</td>
                                    <td className={TD}>{item.actionTypeName}</td>
                                    <td className={TD}>{item.actionAt}</td>
                                    <td className={TD}>{item.sourceName}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className={FOOTER_END}>
                <button type="button" className={SECONDARY_BTN} onClick={onRequestClose}>닫기</button>
            </div>
        </Modal>
    );
};

export default MarketingAgreeHistoryModal;
